import AuthService from '../AuthService'
import { startLoading, setErrorAndStopLoading } from '../apps/components/Notifications'

window.addEventListener('DOMContentLoaded', () => {
  const elements2HideOnly = document.querySelectorAll('.hide-when-logged-in')
  const becomeMemberButtons = document.querySelectorAll('.become-member-button')
  becomeMemberButtons.forEach(el => {
    el.addEventListener('click', e => {
      e.preventDefault()
      try {
        startLoading('authStatus')
        AuthService.signIn()
      } catch (e) {
        setErrorAndStopLoading(e)
      }
    })
  })

  AuthService.on('authenticated', e => {
    [...elements2HideOnly, ...becomeMemberButtons].forEach(el => {
      el.classList.add('is-hidden')
    })
  })
})
